//React
import React from "react";

//UI
import { Select } from "../../Common/Input/index";

//Processing
import { BILLING_TIMELINE } from "../../../utils/onboarding-helper";

const billngTimelineValues = Object.values(BILLING_TIMELINE);

const billngTimlineOptions = billngTimelineValues.map((billingTimeline) => {
  return {
    value: billingTimeline,
    label: billingTimeline,
  };
});

const BillingTimelineSelect = (props) => {
  const { onChange, value } = props;

  return (
    <Select
      value={value}
      onChange={onChange}
      showSearch
      options={billngTimlineOptions}
      className="full-width"
      placeholder="Billing Timeline"
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default BillingTimelineSelect;
